import { NavLink, Link } from "react-router-dom";
import starlogo from "../star_icon.png"

export default function Button() {
    return (
        <>
            <div className="cta">
                <a href="https://github.com/superas0187/superas0187/" activeClassName="activeBtn" className="bg-green-500 py-2 px-5 rounded shadow transition-all duration-300 hover:bg-transparent hover:text-green-500 border-green-500" >
                    <button   >
                        Star&nbsp;<ion-icon name="star" />&nbsp;Me On Github
                    </button>
                </a>
            </div>  
        </>
    )
}
